/**
 * Âmedorée — Size chart drawer
 *
 * Opens on any element carrying [data-size-chart-open].
 *
 * The variant picker is in Stretch's partial-rerender list, so this file can
 * be injected more than once on a single page view. The guard below stops the
 * click handlers being bound twice (which would open and immediately reopen
 * the drawer).
 *
 * Exposes window.AmedoreeSizeChart.open() / .close() for your own code.
 */
(function () {
  'use strict';

  if (window.AmedoreeSizeChart) return;

  var ANIMATION_MS = 340;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getDialog() {
    return document.querySelector('[data-size-chart-dialog]');
  }

  function open() {
    var dialog = getDialog();
    if (!dialog || dialog.open) return;

    dialog.showModal();
    // Force a frame so the closed transform is committed before animating in.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        dialog.classList.add('is-open');
      });
    });
  }

  function close() {
    var dialog = getDialog();
    if (!dialog || !dialog.open) return;

    dialog.classList.remove('is-open');
    window.setTimeout(
      function () {
        if (dialog.open) dialog.close();
      },
      prefersReducedMotion() ? 0 : ANIMATION_MS
    );
  }

  function convertUnits(unit) {
    var table = document.querySelector('[data-size-chart-table]');
    if (!table) return;

    table.querySelectorAll('td[data-cm]').forEach(function (cell) {
      var source = cell.getAttribute('data-cm');

      if (unit === 'cm') {
        cell.textContent = source;
        return;
      }

      // Convert every number found in the cell, so ranges ("96-101") and
      // suffixed values ("96 cm") both survive intact.
      cell.textContent = source.replace(/\d+(?:[.,]\d+)?/g, function (match) {
        var value = parseFloat(match.replace(',', '.'));
        if (isNaN(value)) return match;
        return (Math.round((value / 2.54) * 10) / 10).toString();
      });
    });
  }

  function setUnit(unit) {
    document.querySelectorAll('[data-size-chart-unit]').forEach(function (button) {
      var isActive = button.getAttribute('data-size-chart-unit') === unit;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    convertUnits(unit);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-size-chart-open]');
    if (trigger) {
      event.preventDefault();
      open();
      return;
    }

    if (event.target.closest('[data-size-chart-close]')) {
      event.preventDefault();
      close();
      return;
    }

    var unitButton = event.target.closest('[data-size-chart-unit]');
    if (unitButton) {
      event.preventDefault();
      setUnit(unitButton.getAttribute('data-size-chart-unit'));
      return;
    }

    // A click on the dialog element itself is a click on the backdrop area,
    // since the visible panel is a child that stops the hit test there.
    var dialog = getDialog();
    if (dialog && dialog.open && event.target === dialog) {
      close();
    }
  });

  // Escape: intercept so the panel animates out rather than vanishing.
  document.addEventListener('cancel', function (event) {
    if (!event.target.matches('[data-size-chart-dialog]')) return;
    event.preventDefault();
    close();
  });

  window.AmedoreeSizeChart = { open: open, close: close };
})();
